export const usernameNormalizer = (username) => username.trim();
